import { useState } from 'react'
import { EditPostStateProps } from './useEditPostState.types'

const useEditPostState = ({ postTitle, postRichDescription }: EditPostStateProps) => {
  const [title, setTitle] = useState<string>(postTitle)
  const [richDescription, setRichDescription] = useState<string>(postRichDescription)

  const isDisabled = postRichDescription === richDescription && postTitle === title

  const resetFields = () => {
    setTitle(postTitle)
    setRichDescription(postRichDescription)
  }

  return {
    title,
    richDescription,
    setTitle,
    setRichDescription,
    isDisabled,
    resetFields
  }
}

export default useEditPostState
